"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.DropdownContext = void 0;

var _react = _interopRequireDefault(require("react"));

/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */
var DropdownContext = /*#__PURE__*/_react.default.createContext({});

exports.DropdownContext = DropdownContext;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/~/reactstrap/lib/DropdownContext.js
// module id = 205
// module chunks = 0